<template>

  <b-modal
    v-model="localIsVisible"
    hide-footer
    @cancel="onCancel"
    v-if="insumo"
    size="lg"
  >
    <b-card title="Editar Insumo">
      <b-form @submit.prevent="submitForm">
        <div class="row">
        <b-form-group class="col-3" label="Código:" label-for="codigo">
          <b-form-input
            id="codigo"
            v-model="insumo.codigo"
            type="text"
            required
          />
          
        </b-form-group>

        <b-form-group class="col-9" label="Nombre:" label-for="nombre">
          
          <b-form-input
            id="nombre"
            v-model="insumo.nombre"
            type="text"
            required
          />
        </b-form-group>
        </div>
        <hr>
        <span>Precios:</span>
        <div class="row p-1 align-items-center">
          <div class="col-2">
            <span>Iess</span>
            <b-form-input
            id="precioiess"
            v-model="insumo.precioJson.iess_n1"
            type="text"
            @keypress="soloNumeros"
            required
          />
          </div>
          <div class="col-2">
            <span>Issfa N1</span>
            <b-form-input
            id="precioiess"
            v-model="insumo.precioJson.issfa_n1"
            type="text"
            @keypress="soloNumeros"
            required
          />
          </div>
          <div class="col-2">
            <span>Issfa N2</span>
            <b-form-input
            id="precioiess"
            v-model="insumo.precioJson.issfa_n2"
            type="text"
            @keypress="soloNumeros"
            required
          />
          </div>
          <div class="col-2">
            <span>Isspol</span>
            <b-form-input
            id="precioiess"
            v-model="insumo.precioJson.isspol_n1"
            type="text"
            @keypress="soloNumeros"
            required
          />
          </div>
           <div class="col-2">
            <span>Particular</span>
            <b-form-input
            id="precioiess"
            v-model="insumo.precioJson.particular"
            type="text"
            @keypress="soloNumeros"
            required
          />
          </div>
        </div>
        <hr>
        <span>Activo/Inactivo</span>
        <div class="row p-1">
          <b-form-group class="col" label="Iess:" label-for="estado-1">
          <b-form-checkbox
            id="estado-1"
            v-model="insumo.estadoJson.iess"
            switch
          />
        </b-form-group>
         <b-form-group class="col" label="Issfa:" label-for="estado-2">
          <b-form-checkbox
            id="estado-2"
            v-model="insumo.estadoJson.issfa"
            switch
          />
        </b-form-group>
         <b-form-group class="col" label="Isspol:" label-for="estado-3">
          <b-form-checkbox
            id="estado-3"
            v-model="insumo.estadoJson.isspol"
            switch
          />
        </b-form-group>
         <b-form-group class="col" label="Particular:" label-for="estado-4">
          <b-form-checkbox
            id="estado-4"
            v-model="insumo.estadoJson.particular"
            switch
          />
        </b-form-group>
        </div>
      
     

        <b-row class="mt-3">
          <b-col>

            <b-button type="submit" class="float-right" variant="primary">
              Actualizar
            </b-button>

           

          </b-col>
        </b-row>
      
        

      </b-form>
    </b-card>
  </b-modal>
        
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";


export default {

  name: "EditarInsumo",

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },

    tokenInsumo:{
      type: String,
      default: null
    }
  },

  data() {
    return {
      localIsVisible:false,

      insumo: null,
      token : null,
    };
  },
  created() {    
    this.fetchConsultarinsumo();
  },


  methods: {

    soloNumeros(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const isNumberOrDot = /^[0-9.]$/.test(char);

      // Solo permitir número o punto
      if (!isNumberOrDot) {
        event.preventDefault();
      }

      // Opcional: evitar más de un punto
      const input = event.target;
      if (char === '.' && input.value.includes('.')) {
        event.preventDefault();
      }
    },

    onCancel() {
      this.localIsVisible = false
    },

    convertTojson(jsonString){
      try {
        let json_variable = JSON.parse(jsonString)
        return json_variable
      } catch (error) {
        console.log("error json", error)
      }
    },


    async submitForm() {
      const precioNetoFormateado = parseFloat(
        this.insumo.precioNeto
      ).toFixed(4);
      const precioTechoFormateado = parseFloat(
        this.insumo.precioTecho
      ).toFixed(4);
      const query = `
          mutation Actualizarinsumo($idinsumo: Int!, $datos: InsumoInput!) {
              actualizarInsumo(insumoDatos: {
                  id: $idinsumo,
                  datos: $datos
              }) {
                insumoActualizado {
                  nombre
                  codigo
                  estado
                  numMax
                  precioNeto
                  precioTecho
                  establecimiento{
                    id
                  }
                  presentacion
                }
                message
                status
              }
          }
      `;

      const variables = {
        idinsumo: parseInt(this.insumo.id),
        datos: {
          nombre: this.insumo.nombre,
          codigo: this.insumo.codigo,
          // precioNeto: precioNetoFormateado,
          // precioTecho: precioNetoFormateado,
          presentacion: this.insumo.presentacion,
          precioJson: JSON.stringify(this.insumo.precioJson),
          estadoJson: JSON.stringify(this.insumo.estadoJson),
          estado: this.insumo.estado === true ? '1' : '0',
        },
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
       
        if (response.data.data.actualizarInsumo.status === "success") {
          this.localIsVisible = false
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El insumo se actualizó correctamente.",
          });

          this.$router.go(0)

        } else {
          throw new Error(response.data.data.actualizarInsumo.message);
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text:
            error.message || "Hubo un problema al actualizar el insumo.",
        });
      }
    },
          
    async fetchConsultarinsumo(search = '', paginaActual = 1, establecimiento = '', pageSize ) {

      const query = `
        query GetAllinsumos($tokenInsumo: String, $search: String, $establecimiento: String, $page: Int, $pageSize: Int) {
          allInsumos(tokenInsumo: $tokenInsumo, search: $search, establecimiento: $establecimiento, page: $page, pageSize: $pageSize) {
            total
            status
            message
            insumos {
              id
              token
              estado
              nombre
              codigo
              establecimiento {
                id
                Descripcion
              }
              usuarioCreador {
                id
                username
              }

              precioNeto
              precioTecho
              precioJson
              estadoJson
              numMax
            }
            pageInfo {
              currentPage
              totalPages
              hasNextPage
              hasPreviousPage
            }
          }
        }
      `;
      const token = this.tokenInsumo

      const varConsulta = {
        search: search,
        page: paginaActual,
        pageSize: pageSize,
        tokenInsumo : token, 
        establecimiento: establecimiento.toString()
      }
      try {
        const response = await axios.post(
          rutas.axios + 'api', 
          { query, variables: varConsulta }
        );

        if (response.status === 200) {
          if (response.data.data.allInsumos.status === 'Success') {
            if (response.data.data.allInsumos.insumos) {
              
              const insumo = response.data.data.allInsumos.insumos[0]
              this.insumo = {
                id         : insumo.id,
                nombre     : insumo.nombre,
                codigo     : insumo.codigo,
                estado     : insumo.estado === '1' || insumo.estado === 1 ? true : false,
                precioNeto : insumo.precioNeto,
                precioJson : this.convertTojson(insumo.precioJson),
                estadoJson : this.convertTojson(insumo.estadoJson)

              }

              this.totalRows = response.data.data.allInsumos.total;
              this.currentPage = 1;
              this.currentPageModificado = paginaActual

            } else {
              console.log("No se encontraron insumos");
            }
          } else {
            console.log("Error en la respuesta del servidor");
          }
        }
      } catch (error) {
        console.error("Error fetching insumos:", error);
      }
    },
  },


  watch: {
    tokenInsumo(newValue) {
      this.fetchConsultarinsumo();
    },

    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    }
  }
};
</script>
